import React from "react";
import ReactECharts from "echarts-for-react";
import moment from "moment";
import close from "../../minimise_button.png";



class SRSIChart18Dec extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      option: {
        title: {
          text: props.rname,
          left: 'center',
          top: 10,
          textStyle: {
            fontSize: 14,
            color: "#000000",
          },
        },
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            const { data } = params[0];
            return `Date: ${moment(data[0]).format("DD MMM YYYY")}<br>Index: ${data[1]}`;
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "time",
          name: "Date",
          nameLocation: "middle",
          nameTextStyle: {
            fontSize: 12,
            color: "#000000",
            fontWeight:'bold',
          },
          splitLine:{
            show:false,
          },
          nameGap: 30,
          axisLabel: {
            formatter: (value) => moment(value).format("DD MMM YYYY"),
            fontSize: 11,
            color: "#000",
          },
        },
        yAxis: {
          type: "value",
          min: -2,
          max: 2,
          axisLabel: {
            formatter: (val) => val.toFixed(0),
            color: "#000000",
          },
          name: "Z-Score",
          nameLocation: "middle",
          nameTextStyle: {
            fontSize: 12,
            color: "#000000",
            fontWeight:"bold",

          },
          nameGap: 40,
        },
        toolbox: {
          feature: {
            magicType: {
              type: ["bar", "line"],
              title: {
                line: "Line Chart",
                bar: "Bar Chart",
              },
            },
            restore: {
              title: "Restore",
            },
            myMinimize: {
              show: true,
              title: "Minimize",
              icon: `image://${close}`,
              onclick: this.props.toggleVisibleGraphPanel,
            },
          },
          show: true,
          right: 10,
        },
        dataZoom: [
          // {
          //   type: "slider",
          //   xAxisIndex: 0,
          // },
          {
            type: "inside",
          },
        ],
        series: [
          {
            name: "Index",
            type: "line",
            data: props.data,
            smooth: true,
            lineStyle: {
              width: 2,
              color: "#26a0fc",
            },
            symbol: "none",
            emphasis: {
              focus: "series",
            },
          },
        ],
      },
    };
  }

  render() {
    return (
      <ReactECharts
        option={this.state.option}
        style={{ width: "100%", height: 350 }}
      />
    );
  }
}

export default SRSIChart18Dec;
